<template>
  <div style="max-width: 600px" class="mt-3 card-payment">
    <b-form-group
      label="Card details"
      label-class="required"
      description="Note: Card payments are securely processed by Stripe."
    >
      <b-form-group
        :state="nameState"
        invalid-feedback="Please enter the name on your card"
        class="mb-1"
      >
        <b-input
          v-model="stripe.cardName"
          placeholder="Name on Card"
          name="ccname"
          required
          class="mb-2"
          :state="nameState"
          :form="formid"
          autocomplete="cc-name"
        />
      </b-form-group>

      <b-form-group
        :state="state"
        :invalid-feedback="invalid"
        class="position-relative"
      >
        <input
          class="pseudo-input"
          :value="cardFilled"
          ref="pseudoCard"
          :form="formid"
          required
          autocomplete="pseudo-input"
          name="pseudo-input"
        />
        <div
          ref="card"
          class="form-control"
          :class="{ 'is-invalid': state === false }"
        />
      </b-form-group>
      <b-form-group>
        <b-input-group
          style="width: 100; background: transparent"
          class="card-issue"
          ><span class="required">Card issuing country</span>
          <v-select
            :options="countries"
            :reduce="(c) => c.code"
            label="name"
            style="flex-grow: 1"
            v-model="stripe.cardCountry"
            :clearable="false"
          />
        </b-input-group>
      </b-form-group>
    </b-form-group>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import countryList from "country-list";

export default {
  name: "card-anon",
  props: {
    checkout: Object,
    formid: String,
    axios: Function,
  },
  data() {
    let cardCountry = countryList.getCode(
      this.checkout.Donor_Address_Country || "Singapore"
    );
    return {
      loading: false,
      charge: null,
      cardFilled: "",
      stripe: {
        cardName: "",
        cardCountry,
        base: null,
        elements: null,
        card: null,
        error: null,
        ready: false,
      },
      countries: countryList
        .getData()
        .sort((a, b) => a.name.localeCompare(b.name)),
    };
  },
  async mounted() {
    const stripe = (this.stripe.base = await loadStripe(this.publishableKey));
    const elements = (this.stripe.elements = stripe.elements({
      fonts: [{ cssSrc: "https://fonts.googleapis.com/css2?family=Lato" }],
    }));
    const card = (this.stripe.card = elements.create("card", {
      style: this.styleObject,
      hidePostalCode: true,
      classes: {
        base: "stripe-card",
      },
    }));

    card.mount(this.$refs.card);
    card.on("change", (event) => {
      if (event.error) {
        this.stripe.error = event.error.message;
        this.$refs.pseudoCard.setCustomValidity(this.stripe.error);
      } else {
        this.stripe.error = "";
        this.$refs.pseudoCard.setCustomValidity("");
      }

      if (event.empty) {
        this.cardFilled = "";
      } else {
        this.cardFilled = "Filled";
      }

      this.stripe.ready = event.complete;
    });
  },
  computed: {
    state() {
      return this.stripe.error ? false : null;
    },
    nameState() {
      return this.stripe.ready && !this.stripe.cardName ? false : null;
    },
    invalid() {
      return this.stripe.error || "";
    },
    publishableKey() {
      return this.checkout.stripe_key;
    },
    amount() {
      return this.checkout.Donation_Cash_Value * 100;
    },
    ref() {
      return this.checkout.Reference;
    },
    styleObject() {
      return {
        base: {
          color: "#495057",
          "::placeholder": {
            color: "#6c757d",
          },
          fontSize: "16px",
          lineHeight: "24px",
          fontFamily: "Lato, sans-serif",
        },
      };
    },
  },
  methods: {
    async get_token() {
      const stripe = this.stripe.base;
      return stripe.createToken(this.stripe.card, {
        name: this.stripe.cardName,
        address_country: this.stripe.cardCountry,
      });
    },
    async submit() {
      //only triggered for anonymous
      let { token, error } = await this.get_token();
      if (error) {
        throw "Card Token error";
      }
      await this.axios.post("donations/" + this.ref, {
        action: "pay",
        token,
      });
    },
  },
};
</script>
